import { render, staticRenderFns } from "./WagaDetailIcon.vue?vue&type=template&id=ca8b200e&scoped=true"
import script from "./WagaDetailIcon.vue?vue&type=script&lang=js"
export * from "./WagaDetailIcon.vue?vue&type=script&lang=js"
import style0 from "./WagaDetailIcon.vue?vue&type=style&index=0&id=ca8b200e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8b200e",
  null
  
)

export default component.exports